// Use in GetMediaComponent

import { PropsWithChildren } from 'react';
import { ThemeUIStyleObject } from 'theme-ui';

const ContentSectionPaddingComponent = ({
  forwardSx,
  children,
}: PropsWithChildren<{ forwardSx: ThemeUIStyleObject }>) => {
  return <div sx={{ ...forwardSx }}>{children}</div>;
};

export default ContentSectionPaddingComponent;
